/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/061-coin-euro': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M7.5 1a7.5 7.5 0 100 15 7.5 7.5 0 000-15zm0 13.5a6 6 0 110-12 6 6 0 010 12z"/><path pid="1" d="M10.482 10.068a.5.5 0 00-.684.181A1.51 1.51 0 018.5 11h-2a1.502 1.502 0 01-1.414-1H7.5a.5.5 0 000-1H5V8h2.5a.5.5 0 000-1H5.086c.206-.582.762-1 1.414-1h2a1.51 1.51 0 011.298.751.5.5 0 10.865-.503 2.513 2.513 0 00-2.162-1.249h-2c-1.207 0-2.217.86-2.45 2h-.55a.5.5 0 000 1h.5v1h-.5a.5.5 0 000 1h.55c.232 1.14 1.242 2 2.45 2h2a2.51 2.51 0 002.162-1.249.5.5 0 00-.181-.684z"/>'
  }
})
